// Pure TS: ナビゲーション項目 (React 非依存。icon は MUI アイコン名の文字列)

export type NavGroup = 'crud' | 'sim' | 'runtime';

export type NavigationItem = {
  readonly text: string;
  readonly description: string;
  readonly path: string;
  readonly icon: string;
  readonly group: NavGroup;
};

export const navigationItems: readonly NavigationItem[] = [
  {
    text: 'Robot Profile',
    description: 'client_id ↔ NAME / USER_PARAM',
    path: '/robot-profiles',
    icon: 'SmartToy',
    group: 'crud',
  },
  {
    text: 'Elevator Profile',
    description: 'Mode A / Mode B',
    path: '/elevator-profiles',
    icon: 'Elevator',
    group: 'crud',
  },
  {
    text: 'Elevator Car Profile',
    description: '号機 (bank_id, car_num) ↔ 座標',
    path: '/elevator-car-profiles',
    icon: 'Elevator',
    group: 'crud',
  },
  {
    text: 'HFI Device Profile',
    description: 'object_id ↔ elevator_id / 号機',
    path: '/hfi-device-profiles',
    icon: 'Tablet',
    group: 'crud',
  },
  {
    text: 'Wait Time Config',
    description: '遅延・タイムアウト設定',
    path: '/wait-time-config',
    icon: 'HourglassEmpty',
    group: 'crud',
  },
  {
    text: 'Robot Sim',
    description: 'Robot → HFI Server',
    path: '/sim/robot',
    icon: 'SmartToy',
    group: 'sim',
  },
  {
    text: 'Elevator Sim',
    description: 'Elevator → HFI Server',
    path: '/sim/elevator',
    icon: 'Elevator',
    group: 'sim',
  },
  {
    text: 'State Transition',
    description: 'state_transition 直接 publish',
    path: '/sim/state-transition',
    icon: 'NextPlan',
    group: 'sim',
  },
  {
    text: 'Dashboard',
    description: '稼働サマリ + QR コード',
    path: '/dashboard',
    icon: 'Dashboard',
    group: 'runtime',
  },
  {
    text: 'Sessions',
    description: 'HFI セッションの状態監視',
    path: '/sessions',
    icon: 'EventNote',
    group: 'runtime',
  },
  {
    text: 'MQTT Monitor',
    description: 'IoT Core のメッセージ監視',
    path: '/mqtt-monitor',
    icon: 'Router',
    group: 'runtime',
  },
];

export function findNavigationItem(pathname: string): NavigationItem | undefined {
  return navigationItems.find((item) => pathname.startsWith(item.path));
}
